/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { setSelected, setBlock } from "./withoutRtvSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  StatusFormatter,
  formatCurrency,
  attachFormatter,
} from "../../../../utility";

export const WithoutRtvTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        blockRemark: checkValue(item),
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent == "Y" && row.nra === true) {
      label = "Non Returnable";
    } else if (cellContent == "Y") {
      label = "Within CRP";
    } else if (cellContent == "N") {
      label = "Non CRP";
    } else if (cellContent == "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const StatusFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === true) {
      label = "Yes";
    } else if (cellContent === false) {
      label = "No";
    }

    return <span>{label}</span>;
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;
    if (notSelectableRows.includes(rowIndex)) {
      classes = "disabled-row-table";
    } else {
      classes = "enable-row-table";
    }
    return classes;
  };

  //checker rowRemark
  const checkValue = (value) => {
    let remarkRow = "";
    if (value.customerBlocked === true) {
      remarkRow = "Customer Block.";
    } else if (value.batchStatus === false) {
      remarkRow = "Invalid Batch Number, Please Contact PAM";
    } else if (value.blocked === true) {
      remarkRow = "Material Block. Please Contact PAM";
    } else if (value.materialExcluded === true) {
      remarkRow = "Material Block Exclusion. Please Contact PAM";
    } else if (value.crprgp === "N/A") {
      remarkRow = "CRRGP Block. Please Contact NDC RG Team";
    } else if (value.nra === true) {
      remarkRow = "Non Returnable Client. Please contact NDC RG team";
    } else if (value.availableQty === "0") {
      remarkRow = "Non Returnable available Qty 0";
    } else if (value.netPrice === "0") {
      remarkRow = "Non Returnable Net Price 0";
    } else {
      remarkRow = "";
    }
    return remarkRow;
  };

  let notSelectableRows = [];

  const getNonSelectableRows = (payload) => {
    let nonSelectable = [];
    payload.map((value, index) => {
      if (value.customerBlocked === true) {
        nonSelectable.push(index);
      } else if (value.batchStatus === false) {
        nonSelectable.push(index);
      } else if (value.blocked === true) {
        nonSelectable.push(index);
      } else if (value.materialExcluded === true) {
        nonSelectable.push(index);
      } else if (value.crprgp === "N/A") {
        nonSelectable.push(index);
      } else if (value.availableQty === "0") {
        nonSelectable.push(index);
      } else if (value.netPrice === "0") {
        nonSelectable.push(index);
      }
    });

    return nonSelectable;
  };

  notSelectableRows = getNonSelectableRows(tableData);

  // useEffect(() => {
  //   if (notSelectableRows.length > 0) {
  //     dispatch(setBlock(notSelectableRows));

  //   }
  // }, []);
  const columns = [
    {
      text: "id",
      dataField: "uuid",
      hidden: true,
    },
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "20px" },
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "120px" },
    },
    {
      text: "invoice item number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "Customer Code",
      dataField: "customerCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Tax Invoice No",
      dataField: "taxInvoiceNo",
      style: { minWidth: "180px" },
    },
    {
      text: "Invoice Ref Date",
      dataField: "transactionDate",
      formatter: formatDate,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Code",
      dataField: "clientCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "90px" },
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: formatDate,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Avail Qty",
      dataField: "availableQty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Net Sales",
      dataField: "netPrice",
      formatter: formatCurrency,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Block",
      dataField: "customerBlocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
    },
    {
      text: "Non Returnable",
      dataField: "nra",
      formatter: StatusFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Fullbox Client",
      dataField: "nonFraction",
      formatter: StatusFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Division",
      dataField: "division",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Block Remarks",
      dataField: "blockRemark",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];
  //kalo paginationya hidup
  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  // const options = {
  //   // pageStartIndex: 0,
  //   sizePerPage: 30,
  //   hideSizePerPage: true,
  //   hidePageListOnlyOnePage: true,
  // };

  const onSelectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: notSelectableRows.length > 0 ? true : false,
    nonSelectable: notSelectableRows,
    nonSelectableStyle: { backgroundColor: "gray" },
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  return (
    <>
      <BootstrapTable
        remote
        // wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center"
        bootstrap4
        bordered={false}
        keyField="uuid"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        selectRow={onSelectRow}
        rowClasses={rowClasses}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4">
        <Col sm={1}>
          <Button
            variant="success"
            onClick={() => {
              if (onSelectAll) {
                dispatch(setSelected(data));
                history.push(`/new-return/non-rtv/non-rtv-detail/`);
              } else if (selectedRows.length > 0) {
                dispatch(setSelected(selectedRows));
                history.push(`/new-return/non-rtv/non-rtv-detail/`);
              } else {
                showDialog("Please select row first");
              }
            }}
          >
            Next
          </Button>
        </Col>
        <Col sm={1}>
          <Button variant="outline-danger" onClick={() => history.push("/")}>
            Back
          </Button>
        </Col>
      </Row>
    </>
  );
};
